module.exports = __webpack_public_path__ + "images/interview-Target-2.svg";